// @flow
import config from '../../config';
import { createApiCall } from './api-factory';
import { buildScenarioQueryParams } from './search-scenario-optimizations-request';

const BASE_URL = config.TOTAL_COST_ANALYTICS_URL;

const makeApiCall = createApiCall(BASE_URL, buildScenarioQueryParams);

const getTotalChargeAmount = (query: Query | string): Promise<any> => {
    const endpoint = '/total_charge_amount';
    return makeApiCall(endpoint, query);
};

const getTotalAuditableAmount = (query: Query | string): Promise<any> => {
    const endpoint = '/total_auditable_amount';
    return makeApiCall(endpoint, query);
};

const getAvgTotalChargeAmount = (query: Query | string): Promise<any> => {
    const endpoint = '/average_total_charge_amount';
    return makeApiCall(endpoint, query);
};

const getComparisonTotalChargeAmount = (query: Query | string): Promise<any> => {
    const endpoint = '/comparison_total_charge_amount';
    return makeApiCall(endpoint, query);
};

const getComparisonAvgTotalChargeAmount = (query: Query | string): Promise<any> => {
    const endpoint = '/comparison_average_total_charge_amount';
    return makeApiCall(endpoint, query);
};

const getTotalCostByWeightAndZone = (query: Query | string): Promise<any> => {
    const endpoint = '/total_cost_by_weight_and_zone';
    return makeApiCall(endpoint, query);
};

export {
    getTotalChargeAmount,
    getTotalAuditableAmount,
    getAvgTotalChargeAmount,
    getComparisonTotalChargeAmount,
    getComparisonAvgTotalChargeAmount,
    getTotalCostByWeightAndZone,
};
